<template>
  <div
    style="position: relative;width: 100%;height: 100%;padding-top: 0;"
    infinite-scroll-throttle-delay="200"
    class="list-scroll"
    v-infinite-scroll="getTaskList"
    :infinite-scroll-disabled="loadMore == 'nomore'"
    infinite-scroll-distance="10"
  >
    <div
      v-for="(item, index) in list"
      :key="index"
      class="list-cell"
    >
      <div class="avatar">
        <a-avatar :size="36" :src="item.avatar ? item.avatar : require('../assets/director/director-01.png')" />
      </div>
      <div class="msg">
        <div class="header">
          <div class="teacher">
            {{ item.teacher_name }}
          </div>
          <div class="info">
            发布观察任务
          </div>
          <div class="time" style="margin-right: auto;">
            {{item.start_time}}
          </div>

          <div class="right">
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item v-if="item.send_status == 'wait'" @click="handleToEdit(item)" key="1"> <a-icon type="edit" />修改</a-menu-item>
                <a-menu-item @click="handleDel(item.id)"  key="2"> <a-icon type="delete" />删除 </a-menu-item>
              </a-menu>
              <a-icon type="ellipsis" />
            </a-dropdown>
          </div>
        </div>
        <div class="task-content">
          <div class="cell">
            <div class="label" style="flex-shrink: 0;">
              任务主题：
            </div>
            <div class="info">
              {{ item.record_text }}
            </div>
          </div>
          <div class="cell">
            <div class="label">
              完成时间：
            </div>
            <div class="info">
              {{ item.end_time }}
            </div>
          </div>
          <div class="cell">
            <div class="label">
              任务进度：
            </div>
            <div class="info">
              {{item.success}}/{{ item.total }}
            </div>
            <a-button size="small" @click="select(index)" shape="round"  style="margin-left: 10px;">查看详情</a-button>
          </div>

          <div @click="handleSend(index)" v-if="item.send_status=='wait'" class="send">确认<br>发送</div>
        </div>
      </div>
    </div>

    <a-empty
      style="margin-top: 60px;"
      v-if="list.length == 0 && loadMore == 'nomore'"
    ></a-empty>
    <a-spin v-else :spinning="loading">
      <div style="width: 100%;height: 60px;text-align: center;">
        {{ loading ? "加载中..." : "-没有更多了-" }}
      </div>
    </a-spin>
    <a-drawer
      wrapClassName="drawer-style"
      :visible="showModal"
      :title="false"
      placement="right"
      width="800px"
      :closable="false"
      :get-container="false"
      @close="showModal = false"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <div v-if="currentObserve" class="drawer-content">
        <div class="head flex-row">
          <a-icon
            @click="showModal = false"
            style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
            type="close"
          />
          <div class="title">
            任务完成详情
          </div>
          <a-button @click="getDetail(list[selectIndex].id)" size="small" shape="round"><a-icon type="reload" />刷新</a-button>
          <a-button v-if="list[selectIndex].send_status != 'wait'" @click="transform(list[selectIndex].id)" size="small" shape="round" style="margin-left: 10px;">批量转换快速记</a-button>
          <a-button v-if="list[selectIndex].send_status == 'wait'" @click="$router.push({ path: '/observe/addTask', query: { id: list[selectIndex].id }})" size="small" shape="round" type="primary" style="margin-left: 10px;"><a-icon type="edit" />编辑</a-button>
        </div>

        <div class="teacher flex-row">
          <a-avatar :size="36" :src="currentObserve.teacher_head_img ? currentObserve.teacher_head_img : require('../assets/user_def.png')" ></a-avatar>
          <div class="left">
            <div class="name">{{ currentObserve.teacher_name }}</div>
            <div class="flex-row">
              <div class="school">{{currentObserve.school_name}}</div>
              <div class="time">{{ currentObserve.start_time }} 发布</div>
            </div>
          </div>
        </div>
       

        <div class="content">
          <div class="item">
            <div class="label">任务主题：</div>
            <div class="info">{{ currentObserve.record_text }}</div>
          </div>
          <div class="item">
            <div class="label">完成时间：</div>
            <div class="info">请在{{currentObserve.end_time}}前完成</div>
          </div>
          <div class="item">
            <div class="label">完成进度：</div>
            <div class="info">{{currentObserve.success}} / {{ currentObserve.total }}</div>

            <a-button size="small" type="danger"  @click="handleTipStudent" shape="round">一键提醒</a-button>
          </div>
        </div>
        <div class="split"></div>
        <section class="card">
          <div class="sub-title">任务关联孩子</div>
          <div class="students">
            <div @click="handleSelect(index,item)" v-for="(item, index) in currentObserve.students" :key="index" class="stu-item">
              <div class="name">{{ item.name }}</div>
              <div class="status" :class="item.read_status == '未读' ? 'unread' : item.read_status == '未完成' ? 'read' : item.read_status == '已查阅' ? 'consulted' : item.read_status == '已完成' ? 'check' : ''">{{ item.read_status ? item.read_status : '未读'}}</div>
            </div>
          </div>
        </section>
      </div>
    </a-drawer>

    <a-drawer
      wrapClassName="drawer-style"
      :visible="showDetail"
      :title="false"
      placement="right"
      width="650px"
      :closable="false"
      :get-container="false"
      @close="showDetail = false"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <div v-if="currentCircle" class="drawer-content">
        <div class="head flex-row">
          <a-icon
            @click="showDetail = false"
            style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
            type="close"
          />
          <div class="title" >
            {{ currentCircle.student_name }} 任务详情
          </div>
          <a-space class="right">
            <a-button @click="handleEdit" size="small" >编辑</a-button>
            <a-button @click="handleTransform" size="small" :disabled="currentCircle.transform_notable">{{ currentCircle.transform_notable ? '已转换' : '转换快速记'}}</a-button>
          </a-space>
        </div>

        <div  class="teacher flex-row">
          <a-avatar :size="36" :src="currentCircle.student_avatar"></a-avatar>
          <div class="left">
            <div class="name">{{  currentCircle.user_name }}</div>
            <div class="flex-row">
              <div class="school">{{ currentCircle.school_name + ' ' + currentCircle.class_name  }}</div>
              <div v-if="currentCircle.record_time" class="time">{{ currentCircle.record_time }} 记录</div>
            </div>
          </div>
        </div>
      <div class="msg">
        <div class="task_name">
          {{  '任务：' + currentCircle.task_name }}
        </div>
        <div v-show="currentCircle.title" class="title">{{ currentCircle.title }}</div>
        <div @click="select(index)" class="content">
          {{ currentCircle.record_text }}
        </div>
        <div>
          <file-list :files="currentCircle.att"></file-list>
        </div>
      </div>
      <div class="label-contain" style="margin-top: 15px;padding:0 15px;">
        <div class="form-item">
          <div class="label">关联领域</div>
          <div class="name">
            {{ currentCircle.fields.map(arr=>arr.field_name).join('、') }}
          </div>
        </div>
        
        <div class="form-item">
          <div class="label">发展阶段</div>
          <bea-list backgroundColor="#fff" :showAction="false" :list="currentCircle.target2"></bea-list>
        </div>
      </div>
      </div>
    </a-drawer>
    <a-modal v-model="editModal" title="编辑家长任务详情" :width="800" @ok="confirmEdit">
      <div v-if="currentCircle">
        <circle-edit :id="currentCircle.id" @close="handleClose" :show="editModal" ref="circleEdit"></circle-edit>
      </div>
    </a-modal>
    <a-modal v-model="transformModal" :width="800" title="转换快速记" @ok="confirmTransform" okText="确认转换">
      <div v-if="currentCircle">
        <transform-circle ref="transformCircle" :id="currentCircle.id" :teacher_id="teacher_id" @close="handleClose2" :show="transformModal" ></transform-circle>
      </div>
    </a-modal>
    <a-modal v-model="showTransformModal" :width="800" title="批量转换快速记" @ok="confirmTransformAll" okText="确认转换">
      <div v-if="showTransformModal">
        <transform-circle-all ref="transformAll" :id="transformTaskId" @close="handleCloseTask" :show="showTransformModal" ></transform-circle-all>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios';
import beaList from './bea-list-add.vue';
import { mapState } from 'vuex';
import { directorTestApi } from '../api/api-director';
import qs from 'qs'
import fileList from './fileList.vue';
import circleEdit from './task/edit.vue'
import transformCircle from './task/transform.vue'
import transformCircleAll from './task/transform-all.vue'

export default {
  components: {
    beaList,
    fileList,
    circleEdit,
    transformCircle,
    transformCircleAll
  },
  data() {
    return {
      transformTaskId:'',
      editModal:false,
      transformModal:false,
      selectIndex: 0,
      showModal: false,
      showDetail:false,
      currentCircle:null,
      currentObserve: null,
      students:[],
      loadMore: 'loadmore',
      teacher_id: "",
      timeStamp: 0,
      list: [],
      currentStudent:null,
      form: {
        currentPage: 1,
        etime: "",
        field_id: "",
        name: "",
        pageSize: 10,
        stime: "",
        data_type: "official",
        teacher_id: "",
        student_id:"",
        school_id:""
      },
      showTransformModal:false
    };
  },
  computed: {
    ...mapState(["userInfo", "currentClass"]),
    loading() {
      return this.loadMore == "loading";
    },
  },
  props:{
    stime: {
      type: String,
      default: ""
    },
    etime: {
      type: String,
      default: ""
    },
    student_id: {
      type: String,
      default: "",
    },
  },
  watch: {
      showModal() {
        if (!this.showModal) {
            this.$emit("close");
        }
      },
      student_id() {
        this.list = [];
        this.loadMore = "loadmore";
        this.form.currentPage = 1;
        this.form.student_id = this.student_id;
        this.currentObserve = null
        this.getTaskList();
      },
      userInfo() {
        this.form.teacher_id = this.userInfo.id;
        this.school_id = this.userInfo.school_id
      }
  },
  mounted() {
    this.form.class_id = this.currentClass.id;
    this.form.teacher_id = this.userInfo.id;
    this.form.student_id = this.student_id;
    this.form.school_id = this.userInfo.school_id
    this.getTaskList();
  },
  methods: {
    transform(id) {
      this.transformTaskId = id 
      this.showTransformModal = true
    },
    confirmTransform() {
      if (!this.currentCircle.transform_notable) {
        this.$refs.transformCircle.handlePush()
      } else {
        this.$message.error('已转换过，请勿重复转换')
      }
    },
    confirmTransformAll() {
      this.$refs.transformAll.handlePush()
    },
    handleClose() {
      this.editModal = false;
      this.getCircleDetail(this.currentStudent)
    },
    handleClose2() {
      this.transformModal = false;
      this.getCircleDetail(this.currentStudent)
    },
    handleCloseTask() {
      this.showTransformModal = false;
      // this.getDetail(this.currentObserve.id)
    },
    confirmEdit() {
      this.$refs.circleEdit.handlePush()
    },
    reSearch() {
      this.list = [];
      this.loadMore = "loadmore";
      this.form.currentPage = 1;
      this.getTaskList();
    },
    reSet() {
      this.form.stime = "";
      this.form.etime = "";
    },
    getTaskList() {
      if (this.loadMore != 'loadmore' || !this.userInfo) return
      this.timeStamp = new Date().getTime()
      this.form.stime = this.stime
      this.form.etime = this.etime
      this.loadMore = 'loading'
      const time = this.timeStamp
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserTaskList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          ...this.form,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        console.log(this.timeStamp,time)
        if (res.data.result) {
          if (this.timeStamp != time) return
          this.loadMore = 'loadmore'
          this.form.currentPage++
          this.list = [...this.list , ...res.data.data]
          if (res.data.data.length < this.form.pageSize) {
            this.loadMore = 'nomore'
          }
        } else {
          this.loadMore = 'nomore'
        }
      }).catch((e) => {
        console.log(e);
        this.loadMore = 'loadmore'
        this.busy = false
        this.$message.error('网络服务错误')
      })
    },
    handleToEdit(item) {
      this.$router.push({
        path: '/observe/addTask',
        query: {
          id: item.id
        }
      })
    },
    handleSelect(index,item) {

      if (item.obser_circle_id) {
        this.currentStudent = item
        this.getCircleDetail(item)
      }
    },
    handleEdit() {
      this.editModal = true
    },
    handleTransform() {
      this.transformModal = true
    },
    select(index) {
      this.selectIndex = index;
      // this.currentObserve = this.list[index];
      this.getDetail(this.list[index].id)
      // this.showModal = true;
    },
    getDetail(id) {
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      })
      axios({
        url: directorTestApi.main + directorTestApi.getObserTaskDetail,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        method: "POST",
        data: qs.stringify({
          id,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || ""
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "加载成功",
            key: "loading",
            duration: 0.5
          })
          this.currentObserve = res.data.data;
          this.showModal = true
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getCircleDetail(student) {
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      })
      axios({
        url: directorTestApi.main + directorTestApi.getTeacherObserCircleDetail,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        method: "POST",
        data: qs.stringify({
          id: student.obser_circle_id,
          student_id: student.id,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "加载成功",
            key: "loading",
            duration: 0.5
          })
          this.teacher_id = res.data.data.teacher_id
          this.currentCircle = res.data.data;
          this.showDetail = true
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleTipStudent() {
      this.$confirm({
        title: "提示",
        content: "确定提醒所有未完成任务的孩子家长吗？",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          this.$message.success('已发送提醒')
        },
        onCancel: () => {

        },
      });
    },
    handleSend(index) {
      this.$confirm({
        title: "提示",
        content: "确认发送家长后，任务内容不可修改，请确认！",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          axios({
            url: directorTestApi.main + directorTestApi.sendTask,
            headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
            method: "POST",
            data: qs.stringify({
              id: this.list[index].id,
              teacher_id: this.userInfo.id,
            }),
          }).then((res) => {
            if (res.data.result) {
              this.$message.success('任务发送成功')
              this.list[index].send_status = 'success'
            } else {
              this.$message.error(res.data.message);
            }
          });
          
        },
        onCancel: () => {},
      });
    },
    handleDel(id) {
      this.$confirm({
        title: "提示",
        content: "确定删除吗？",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          axios({
            url: directorTestApi.main + directorTestApi.delObserAll,
            headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
            method: "POST",
            data: qs.stringify({
              id: id ,
              teacher_id: this.userInfo.id
            })
          }).then((res) => {
            if (res.data.result) {
              this.list = this.list.filter(item => item.id != id)
              this.showModal = false
              this.selectIndex = -1
              this.currentObserve = null
              this.$message.success("删除成功");
            } else{
              this.$message.error(res.data.message);
            }
          })
        },
        onCancel: () =>{},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
input[aria-hidden="true"] {
        display: none !important;
    }
.split {
  height: 10px;
  background: #f1f1f1;
}

.students {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  user-select: none;

  .stu-item{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 140px;
    margin-top: 10px;

    .name {
      width: 58px;
      cursor: pointer;
    }

    .status {
      background: #e68b39;
      color: #fff;
      padding: 3px 10px;
      border-radius: 20px;
      font-size: 12px;
      cursor: pointer;
      user-select: none;

      &.unread{
        background: #dc4c32;
      }

      &.check{
        background: #77a1bf;
      }

      &.consulted{
        background: #71a06a;
      }
    }
  }
}

.drawer-content {
  .msg {
    padding-top: 10px;
    .task_name {
      border: 1px dashed #67b0dc;
      padding: 3px 5px;
      margin: 15px 0 10px 15px;
      border-radius: 2px;
      width: fit-content;
      color:  #67b0dc;
      font-size: 12px;
      margin-top: 6px;
    }
    .title {
      font-weight: bold;
      font-size: 14px;
      color: #333;
      margin-left: 15px;
      line-height: 20px;
      border-bottom: 1px dotted #333;
      width: fit-content;
    }
    .file {
      padding:0 15px;
    }
    .content {
      padding: 5px 15px;
    }
  }
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      font-family: "微软雅黑";
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .teacher {
    padding: 15px;
    border-bottom: 1px solid #ececec;
    .left {
      flex-direction: column;
      align-items: flex-start;
      font-size: 12px;
      color: #6a6a6a;
      margin-left: 10px;
      .name {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .flex-row {
      justify-content: space-between;
      width: 100%;
    }
  }

  .content {
    padding: 15px;

    .item {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 15px;
      margin-bottom: 4px;
      .label{
        width: 90px;
      }

      .info {
        color: #444;
        margin-right: auto;
      }

    }
  }
}

.task-mb {
  width: 100%;
  padding: 6px;
  background: #efefef;
  border-radius: 5px;
  margin: 10px 0;
  .cell {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    .range {
      margin-right: 10px;
      margin-top: 4px;
    }

    .range-level{
      flex: 1;
      .item {
        width: 100%;
        margin: 3px 0;
        .level{
          display: inline-block;
          padding: 2px 4px;
          border-radius: 8px 2px 8px 2px;
          border: 1px solid #519fd3;
          line-height: 1;
          font-size: 12px;
          margin-right: 3px;
        }

        .name {
          display: inline-block;
        }
      }
    }
  }
}

.task-content {
  position: relative;
  .send{
    position: absolute;
    right: 10px;
    bottom: 0;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 15px;
    background: #e58a38;
    color: #fff;
    padding-top: 10px;
    font-size: 12px;
    border-radius: 100%;
    user-select: none;
    cursor: pointer;
    &:hover{
      background: #da853b;
    }
  }
  .cell {
    display: flex;
    flex-direction: row;
    align-items: center;

    .label {
      margin-right: 6px;
    }

    &:last-child{
      margin-top: 2px;
    }
  }
}
.list {
  padding: 0 15px;
}
.list-cell {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px 0 30px 0;
  cursor: pointer;
  .avatar {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }
  .msg {
    flex: 1;
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      color: #101010;
      .teacher {
        font-weight: bold;
        font-size: 14px;
      }

      .students {
        font-weight: bold;
      }

      .action {
        margin: 0 6px;
      }

      .info {
        margin-left: 10px;
        font-weight: bold;
      }

      .time {
        margin: 0 10px;
      }

      .status {
        color: #519fd3;
      }
    }

    .content {
      margin-top: 6px;
      color: #6a6a6a;
    }
  }
}

.file {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  .item {
    width: 20%;
    display: block;
    padding-bottom: 20%;
    background: #eee;
    overflow: hidden;
    border-radius: 5px;
  }
}

.card {
  padding: 15px;
  .sub-title {
    font-size: 14px;
    font-weight: 500;
    color: #101010;
  }

  .status {
    color: #519fd3;
  }
  .names {
    color: #666;
    margin-top: 4px;
  }
}

.form-item {
		margin-bottom: 20px;
	}
	
	.form-item .label {
		position: relative;
		padding-left: 10px;
		line-height: 1.4;
		font-size: 14px;
		color: #555;
		font-weight: 600;
		margin-bottom: 10px;
	
		&::before {
			position: absolute;
			content: "";
			left: 0px;
			top: 2px;
			width: 3px;
			background: #73b5de;
			bottom: 2px;
		}
	
		text {
			color: red;
			margin-left: 1px;
			font-weight: normal;
		}
	
		text.tip {
			color: #999;
			font-weight: 400;
			margin-left: 5px;
		}
	}
</style>
